// Настройки установки (GET /system/settings, без входа): включённые модули
// и их публичные настройки.  Нужны в том числе киоску без пользователя.

import { useQuery } from "@tanstack/react-query";

import { request } from "./api";

export interface SystemSettings {
  corporate_domain: string | null;
  app_url: string | null;
  modules: string[];
  module_settings: Record<string, unknown>;
  company: { app_title: string; name: string; contact_email: string | null; passport_text_color: string };
}

export function useSystemSettings() {
  return useQuery({
    queryKey: ["system", "settings"],
    queryFn: () => request<SystemSettings>("/system/settings"),
    staleTime: 60_000,
  });
}

/** Строковая настройка модуля или запасное значение, пока настройки грузятся. */
export function useModuleSetting(key: string, fallback: string): string {
  const q = useSystemSettings();
  const v = q.data?.module_settings[key];
  return typeof v === "string" && v ? v : fallback;
}
